<tds-folder-tabs>
    <tds-folder-tab style="margin-top: 4px;">
        <button (click)="showThis('detailed-reporting')">Detailed report</button>
    </tds-folder-tab>
    <tds-folder-tab style="margin-top: 4px;">
        <button (click)="showThis('groupprojectreport')">Project report</button>
    </tds-folder-tab>
    <tds-folder-tab *ngIf="showTab()" style="margin-top: 4px;">
        <button (click)="showThis('groupmonthreport')">Group report month</button>
    </tds-folder-tab >
    <tds-folder-tab *ngIf="showTab()" style="margin-top: 4px;">
        <button (click)="showThis('groupweekreport')">Group report week</button>
    </tds-folder-tab>
    <tds-folder-tab *ngIf="showTab()" style="margin-top: 4px;">
        <button (click)="showThis('groupadmin')">Group admin</button>
    </tds-folder-tab>
</tds-folder-tabs>

<div *ngIf="visibleReport === 'detailed-reporting'" class="tds-u-pt2">
    <detailed-reporting></detailed-reporting>
</div>
<div *ngIf="visibleReport === 'groupprojectreport'" class="tds-u-pt2">
    <groupprojectreport></groupprojectreport>
</div>
<div *ngIf="showTab() && visibleReport === 'groupmonthreport'" class="tds-u-pt2">
    <groupmonthreport></groupmonthreport>
</div>
<div *ngIf="showTab() && visibleReport === 'groupweekreport'" class="tds-u-pt2">
    <groupweekreport></groupweekreport>
</div>
<div *ngIf="showTab() && visibleReport === 'groupadmin'" class="tds-u-pt2">
    <groupadmin></groupadmin>
</div>
